import { ApolloError, gql, useMutation } from "@apollo/client";

import {
  AddDevicesTemplateInput,
  AddDevicesTemplateMutation,
  AddDevicesTemplateMutationVariables,
} from "../../../../../API";
import { ADD_DEVICES_TEMPLATE } from "../../../../../common/operations/mutations";
import {
  errorNotification,
  successNotification,
} from "../../../../../common/variables/notification";

export const useCreateDevicesTemplate = () => {
  const [saveDevicesTemplate, { data, loading }] = useMutation<
    AddDevicesTemplateMutation,
    AddDevicesTemplateMutationVariables
  >(ADD_DEVICES_TEMPLATE);

  const createDevicesTemplate = (input: AddDevicesTemplateInput) => {
    return saveDevicesTemplate({
      variables: {
        input,
      },
      onCompleted: response => {
        if (response.addDevicesTemplate) {
          successNotification();
        }
      },
      onError: (error: ApolloError): void => {
        errorNotification(error.message);

        console.error(error.message);
      },
      update: (cache, response): void => {
        cache.modify({
          fields: {
            getDeviceTemplates(existing) {
              const newDeviceTemplateRef = cache.writeFragment({
                data: response.data?.addDevicesTemplate,
                fragment: gql`
                  fragment NewDeviceTemplate on DeviceTemplate {
                    id
                    name
                    numberOfNodes
                    templateData
                  }
                `,
              });

              if (!existing) {
                return response?.data;
              }

              return {
                ...existing,
                items: [...existing.items, newDeviceTemplateRef],
              };
            },
          },
        });
      },
    });
  };

  return { createDevicesTemplate, data, loading };
};
